import industrial from "../../images/productsImages/filterImages/comercial.jpg";
import residential from "../../images/productsImages/filterImages/residencial.jpg";
import residentialIcon from "../../images/productsImages/filterImages/residencialIcon.svg";
import industrialIcon from "../../images/productsImages/filterImages/comercial.svg";

const filtercomercialList = [
  {
    _id: "filtcatcomer001",
    title: "Sistemas OneStop",
  },
  {
    _id: "filtcatcomer002",
    title: "Purificador",
  },
  {
    _id: "filtcatcomer003",
    title: "Suavizador",
  },
];
const filterResidentialList = [
  {
    _id: "filtcatresi001",
    title: "Carcasa",
  },
  {
    _id: "filtcatresi002",
    title: "Elementos Filtrantes",
  },
  {
    _id: "filtcatresi003",
    title: "Sistemas de filtrado",
  },
];

const filterList = [
  {
    _id: "filt001",
    image: industrial,
    title: "Comercial",
    link: "/productos/filtros/comercial",
    list: filtercomercialList,
    path: "comercial",
    icon: industrialIcon,
  },
  {
    _id: "filt002",
    image: residential,
    title: "Residencial",
    link: "/productos/filtros/residencial",
    list: filterResidentialList,
    path: "residencial",
    icon: residentialIcon,
  },
];

export { filterList };
